import type { PropsWithChildren, ReactNode } from 'react';
import type { FeatureInput } from '../hooks/useFeatureGatePlanSuggestion';
import { useFeatureGatePlanSuggestion } from '../hooks/useFeatureGatePlanSuggestion';

type FeatureGateConditionalRenderProps = PropsWithChildren<{
  /** The feature we are checking */
  feature: FeatureInput;
  /** The content we will render when the feature is disabled */
  fallback?: ReactNode;
}>;

export function FeatureGateConditionalRender({
  children,
  fallback,
  feature,
}: FeatureGateConditionalRenderProps) {
  const featureGatePlanSuggestion = useFeatureGatePlanSuggestion(feature);

  if (featureGatePlanSuggestion?.includedInCurrentPlan) return children;

  return fallback;
}
